import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { VisaService } from '../../services/visa.service';
import { ContactService } from '../../services/static-page/contact.service';
@Component({
  selector: 'app-visa-detail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './visa-detail.component.html',
  styleUrl: './visa-detail.component.scss',
})
export class VisaDetailComponent implements OnInit {
  _visaService = inject(VisaService);

  @Input() visaCountry: string = this._visaService.getVisaCountry().name;
  @Input() visitReason: string = this._visaService.getVisitReason().name;
  @Input() visaType: string = this._visaService.getVisaType()?.name;
  @Input() applicationType: string = '';
  @Input() total: number = 0;
  @Input() visaLevel: string = '';
  @Input() showResult: boolean = false;

  constructor(private readonly contactService: ContactService, @Inject(PLATFORM_ID) private platformId: Object) {
    this._visaService.visaCountry$.subscribe((data) => {
      this.visaCountry = data.name;
    });
    this._visaService.visitReason$.subscribe((data) => {
      this.visitReason = data.name;
    });
    this._visaService.visaType$.subscribe((data) => {
      this.visaType = data?.name;
    });
  }

  contact: any;
  locationLink: any;

  async ngOnInit(): Promise<void> {
    const data = this._visaService.getVisaCountry();
    try {
      let data = await firstValueFrom(this.contactService.getContact());
      this.contact = data[0];
      const regex = /src="([^"]*)"/;
      const match = this.contact.locationLink.match(regex);
      this.locationLink = match ? match[1] : null;
    } catch (error) {
      // Hata durumunda varsayılan değerler
      this.contact = {
        email: 'info@vizeasist.com',
        phone: '+90 xxx xxx xx xx',
        locationLink: ''
      };
      this.locationLink = null;
    }
  }
}
